import PayrollRequestAPI from './api'
import { objectToCamelCase, objectToSnakeCase } from '../utils'
import options from './options'

export default class PayrollRequest {
  static api = PayrollRequestAPI.create(PayrollRequest)
  static options = options
  static readOnlyFields = ['id', 'datetimeCreated']
  constructor({
    id = '',
    datetimeCreated = null,
    firstName = '',
    lastName = '',
    email = '',
    employeeId = '',
    zipCode = '',
    user = null,
    donor = null,
    amount = null,
    currency = null,
    frequency = null,
    emailToPayrollSent = null,
  } = {}) {
    Object.assign(this, {
      id,
      datetimeCreated,
      firstName,
      lastName,
      email,
      employeeId,
      zipCode,
      user,
      donor,
      amount,
      currency,
      frequency,
      emailToPayrollSent,
    })
  }

  static create(opts) {
    return new PayrollRequest(opts)
  }

  static fromAPI(json = {}) {
    return new PayrollRequest(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(payrollRequest, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = payrollRequest[field]
      })
    } else {
      data = payrollRequest
    }

    //
    excludeFields = [...PayrollRequest.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
}
